import FAQ from './FAQ';

export default function FAQComponent() {
  return <FAQ />;
}
